export const REFERENCE_RATE_BASIS_KEYS = {
  FIXED: 'FIXED',
  FLOATING: 'FLOATING',
}

export const REFERENCE_RATE_BASIS = [
  { id: REFERENCE_RATE_BASIS_KEYS.FIXED, displayValue: 'Fixed' },
  { id: REFERENCE_RATE_BASIS_KEYS.FLOATING, displayValue: 'Floating' },
];
